module.exports = __webpack_public_path__ + "static/brv5-final-shows.d563da3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/brv5-final-shows.png
// module id = ./src/pages/brv5-final-shows.png
// module chunks = 19913542803863